import { BookOpenIcon, CheckCircle } from '@components/Icons';
import { useSessionFeatureState } from '@hooks/storeHooks/useSessionState';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDataChannel } from '../../../features/AvatarSession/hooks/useDataChannel';

const CorrectDTButton: React.FC = memo(() => {
  const { t } = useTranslation();
  const { isTwinUpdating, setIsTwinUpdating } = useSessionFeatureState();
  const { sendMessage, isOpen } = useDataChannel();

  const handleClick = () => {
    const newState = !isTwinUpdating;
    setIsTwinUpdating(newState);

    if (isOpen) {
      const message = {
        type: 'send_function_command',
        data: {
          command: newState ? 'start_edit_mode' : 'stop_edit_mode',
          parameters: null,
          interrupt: true,
        },
      };
      sendMessage(message);
    } else {
      console.warn('DataChannel is not open, cannot send message');
    }
  };

  return (
    <div className="tc-mv-blur-4 rounded-2xl py-4 px-6 flex flex-col items-center gap-4 w-[270px]">
      <div className="text-white text-center text-sm">
        {isTwinUpdating ? (
          <p>{t('generation.speakCorrections')}</p>
        ) : (
          <p>{t('generation.changeWhatTwinKnows')}</p>
        )}
      </div>
      <button
        className="btn btn-primary btn-sm"
        onClick={handleClick}
        id="correct_me">
        {isTwinUpdating ? (
          <>
            <CheckCircle size={14} />
            &nbsp;{t('generation.imDone')}
          </>
        ) : (
          <>
            <BookOpenIcon size={20} />
            &nbsp;{t('generation.correctMe')}
          </>
        )}
      </button>
    </div>
  );
});

export { CorrectDTButton };
